import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import {
  AccordionDetails,
  Alert,
  Button,
  Checkbox,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  styled,
  TextField,
  Typography
} from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import FormGroup from '@mui/material/FormGroup';
import PropTypes from 'prop-types';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FileUpload } from 'src/components/common/FileUpload';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { sectionNames } from 'src/components/QueryMenus/checklistQueriesData';
import { QueryMenus } from 'src/components/QueryMenus/QueryMenus';
import { SectionQueryIndication } from 'src/components/QueryMenus/sectionQueryIndication';
import { useQueryMenus } from 'src/components/QueryMenus/useQueryMenus';
import { ViewQuery } from 'src/components/QueryMenus/ViewQuery/ViewQuery';
import { sendRequest } from 'src/hooks/useFetch';
import { AppState, store } from 'src/store';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import './sqReport.scss';
import { SQReportRow } from './SQReportRow';
import { useMonitoringVisitLog } from '../studyLogs/MonitoringVisitLogs/useMonitoringVisitLog';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import moment from 'moment';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { SERVER_DATE_FORMAT } from 'src/constants/formats';
import { showLoader, hideLoader } from 'src/store/Loader';
import Loader from 'src/components/common/Loader';
import ESignConsentReAuth from 'src/components/common/ESignConsentReAuth';
import { useValidUserForReAuth } from 'src/components/hooks/useValidUserForReAuth';
import { getUTCDateTimeOfNow } from 'src/util/util';
import { useLazySetESignQuery } from 'src/services/ESignAPI';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

const BootstrapDialogTitle = (props: { [x: string]: any; children: any; onClose: any }) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};

const SQReport: FC<any> = ({
  setAgree,
  agree,
  sqReport,
  setSqReport,
  setSqReportData,
  sqReportData,
  getSqReportData,
  fileObjects,
  setFileObjects,
  isUpdate,
  reviewerName,
  setData1,
  validationObjSqReportData,
  setValidationObjSqReportData,
  setQCReportSaved,
  saveDisable,
  setConfirmation,
  submitStatusChange,
  submitStatus,
  setSubmitStatus,
  createSqReport,
  updateSqReport,
  VisitCodeListData,
  LocationCodeListData,
  ResponseCodeListData,
  StatusCodeListData,
  sitestudySiteInfo,
  checkedInStartDate,
  setSaveDisable
}) => {
  const { qualificationReport } = useFieldTranslation();
  const [openUploadDocument, setOpenUploadDocument] = React.useState(false);
  const [enable, setEnable] = useState<boolean>(false);
  const { user } = useUser();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const selectedRowData: any = useAppSelector(state => state.sqReport.selectedRowData);
  const {
    sqrDataUpdateSuccessMsg,
    sqrErrorMsg,
    sqrPresentDoumentErrorMsg,
    sqrFileUploadErrorMsg,
    sqrFileDeleteSuccessMsg
  } = useFieldTranslation();
  useMonitoringVisitLog();
  const dispatchApp = useAppDispatch();
  const handleClose = () => {
    // setOpen(false);
  };
  const { checkPermission } = usePermissionWrapper();
  const perDisable = checkPermission('update_sq_report');
  const readOnlyUser = checkPermission('view_sq_report_after_submit');
  const [isSubmitEnable, setIsSubmitEnable] = useState(false);
  const [recentData, setRecentData] = useState({ data: {}, mandatoryValidation: {} });
  const sitestudypersonnelData = useSelector((state: AppState) => state.sitestudypersonnelData.sitestudypersonnelData);
  const setDocumentUploadInfo = () => {
    const newElement = document.createElement('div');
    newElement.innerHTML =
      '<span class="other-doc-upload-message"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit css-1vooibu-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="InfoOutlinedIcon"><path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"></path></svg> Documents uploaded here are not stored in eTMF</span>';
    const referenceElement: any = document.querySelector('.pi-document-upload');
    referenceElement?.parentNode.insertBefore(newElement, referenceElement.nextSibling);
  };
  const handleClickOpenUploadDocument = () => {
    setOpenUploadDocument(true);
    setTimeout(() => {
      setDocumentUploadInfo();
    }, 100);
  };
  const handleCloseUploadDocument = () => {
    setEnable(true);
  };

  const handleClosePopUp = () => {
    setEnable(false);
  };

  const clearData = () => {
    setEnable(false);
    setOpenUploadDocument(false);
  };

  // let newAr: any = [];
  const [newAr, setNewAr] = useState<any>([]);
  //setFileObjects(newAr);
  const handleUploadDocument = () => {
    //setFileObjects(newAr);
    const nameArr = newAr.map((ele: any) => {
      return ele.name;
    });
    const duplicate = nameArr.some((item: any, idx: number) => {
      return nameArr.indexOf(item) !== idx;
    });
    if (duplicate) {
      dispatchApp(setMessage({ msgDetails: 'Please Remove Duplicate file', severity: 'error' }));
    } else {
      uploadDataFile();
      setIsSubmitEnable(false);
    }
  };

  const uploadOtherDocuments = async (files: any): Promise<any> => {
    try {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }
      const options = {
        data: formData,
        pathVariables: {
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          appName: process.env.REACT_APP_NAME
        }
      };
      const response: any = await sendRequest('sqreport_filemaster_Other_Upload_Documents', options);

      return response;
    } catch {
      dispatchApp(setMessage({ msgDetails: sqrFileUploadErrorMsg, severity: 'error' }));

      return Promise.reject();
    }
  };

  const uploadDataFile = async (): Promise<any> => {
    if (newAr.length > 0) {
      const fileExist = newAr.filter((o1: any) => fileObjects.some((o2: any) => o1.path === o2.ctms_raw_file_name));
      if (fileExist.length > 0) {
        store.dispatch(dispatchApp(setMessage({ msgDetails: sqrPresentDoumentErrorMsg, severity: 'error' })));
      } else {
        const result = await uploadOtherDocuments(newAr);
        if (Array.isArray(result)) {
          setFileObjects([...fileObjects, ...result]);
        }
      }
    }
    setOpenUploadDocument(false);
  };

  if (submitStatus == 'Draft') {
    setSubmitStatus('1');
  } else if (submitStatus == 'Under Review') {
    setSubmitStatus('2');
  }
  const [deleteUploadPopup, setDeleteUploadPopup] = useState(false);
  const [deleteFileId, setDeleteFileId] = useState('');
  const handleRemoveItem = async () => {
    // const isConfirmed = window.confirm('Do you want to delete the uploaded document?');
    if (deleteFileId) {
      try {
        // setFileObjects(fileObjects.filter((item:any) => item.path !== name))
        const options = {
          file_id: deleteFileId,
          pathVariables: {
            study_id: studyId,
            country: selectedCountry,
            site_id: selectedSite,
            appName: process.env.REACT_APP_NAME
          }
        };
        await sendRequest('sqreport_delete_filemaster-Upload-Documents', options);
        const files = fileObjects.filter((item: any) => item.id !== deleteFileId);
        setFileObjects(files);
        setDeleteUploadPopup(false);
        setDeleteFileId('');
        dispatchApp(setMessage({ msgDetails: sqrFileDeleteSuccessMsg, severity: 'success' }));
      } catch (e: any) {
        dispatchApp(setMessage({ msgDetails: e.message, severity: 'error' }));
      }
    }
  };

  const checkboxHandler = (e: any) => {
    if (e.target.checked) {
      setAgree(true);
      setConfirmation(true);
    } else {
      setAgree(false);
      setConfirmation(false);
    }
    setConfirmExitValue(dispatchApp, true);
  };

  setData1(sqReportData);

  const isValidsiteInfoData = () => {
    const newValidObj: any = { ...validationObjSqReportData };
    const validationArr: any = [];
    for (const key of Object.keys(validationObjSqReportData)) {
      if (sqReportData[key] === '' || sqReportData[key] === null) {
        if (key === 'sq_visit_date') {
          if (checkedInStartDate) {
            newValidObj[key] = false;
          } else {
            newValidObj[key] = true;
            validationArr.push(false);
          }
        } else {
          newValidObj[key] = true;
          validationArr.push(false);
        }
      } else {
        newValidObj[key] = false;
      }
    }
    setValidationObjSqReportData(newValidObj);
    if (validationArr.includes(false)) {
      return true;
    } else {
      return false;
    }
  };
  const handleSave = () => {
    setSqReportData({
      ...sqReportData,
      ...recentData.data,
      site_id: selectedSite,
      study_id: studyId,
      monitoring_visit_id: selectedRowData.id
    });
    setValidationObjSqReportData({ ...validationObjSqReportData, ...recentData.mandatoryValidation });
    if (!isValidsiteInfoData()) {
      const filesIDs = fileObjects?.map((file: any) => {
        return file.id;
      });
      const reqObj = {
        report_data: { ...sqReportData, ...recentData.data },
        file_ids: filesIDs
      };
      const clonedObj: any = JSON.parse(JSON.stringify(reqObj));
      if (checkedInStartDate) {
        clonedObj.report_data.sq_visit_date = moment(checkedInStartDate).format(SERVER_DATE_FORMAT);
      } else {
        clonedObj.report_data.sq_visit_date = moment(clonedObj.report_data.sq_visit_date).format(SERVER_DATE_FORMAT);
      }
      // need to remove
      if (isUpdate) {
        delete clonedObj.report_data.created_by;
        delete clonedObj.report_data.created_on;
        delete clonedObj.report_data.deleted_by;
        delete clonedObj.report_data.deleted_on;
        delete clonedObj.report_data.id;
        delete clonedObj.report_data.site_id;
        delete clonedObj.report_data.updated_on;
        clonedObj.report_data.updated_by = user;
      } else {
        delete clonedObj.report_data.updated_by;
        clonedObj.report_data.created_by = user;
        clonedObj.report_data.site_id = selectedSite;
        clonedObj.report_data.study_id = studyId;
      }
      clonedObj.report_data.sq_report_status_value_code = submitStatus;
      clonedObj.report_data.sq_report_notify_review = reviewerName;
      clonedObj.report_data.sq_project_manager = reviewerName;
      clonedObj.report_data.sq_report_certify_info = agree;
      postData(clonedObj);
      setConfirmExitValue(dispatchApp, false);
    } else {
      dispatchApp(setMessage({ msgDetails: 'Missing mandatory data', severity: 'error' }));
    }
  };

  const postData = async (reqObj: any) => {
    try {
      let result: any = null;
      if (isUpdate) {
        result = await updateSqReport({
          site_id: selectedSite,
          study_id: studyId,
          data: reqObj,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
      } else {
        result = await createSqReport({
          site_id: selectedSite,
          study_id: studyId,
          data: reqObj,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
        setReportId(result?.data?.id);
      }
      store.dispatch(dispatchApp(setMessage({ msgDetails: sqrDataUpdateSuccessMsg, severity: 'success' })));
      setQCReportSaved(true);
      getSqReportData();
      setSaveDisable(true);
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: sqrErrorMsg, severity: 'error' }));
      setQCReportSaved(false);
    }
  };

  const sqReportStudyId = async () => {
    setSqReport({
      ...sqReport,
      site_id: selectedSite,
      study_id: studyId
    });
  };

  useEffect(() => {
    sqReportStudyId();
  }, [sitestudypersonnelData]);

  const handleCheck = (e: any) => {
    if (e.target.type === 'radio') {
      const data = e.target.value;
      const formattedVal = typeof data === 'string' ? formatInput(data) : data;
      setSqReportData({
        ...sqReportData,
        [e.target.name]: formattedVal,
        site_id: selectedSite,
        study_id: studyId,
        monitoring_visit_id: selectedRowData.id
      });
      if (Object.keys(validationObjSqReportData).includes(e.target.name)) {
        setValidationObjSqReportData({ ...validationObjSqReportData, [e.target.name]: false });
      }
      if (saveDisable && data && e.target.type === 'radio') {
        setSaveDisable(false);
      }
    }
    setConfirmExitValue(dispatchApp, true);
  };

  const handleChange = (e: any) => {
    if (e.target.type !== 'radio') {
      const data = e.target.value;
      const formattedVal = typeof data === 'string' ? formatInput(data) : data;
      setRecentData({
        data: {
          ...recentData.data,
          [e.target.name]: formattedVal
        },
        mandatoryValidation: { ...recentData.mandatoryValidation, [e.target.name]: false }
      });
    }
    if (saveDisable) {
      setSaveDisable(false);
    }
  };

  const handleRejectedMessage = (rejectedFile: any, acceptedFiles: any, maxFileSize: any) => {
    let message = `${rejectedFile.name} cannot be uploaded! , `; // const maxFileSize=5000000;

    const arrFile = rejectedFile.name.split('.');
    if (!acceptedFiles.includes(`.${arrFile[arrFile.length - 1]}`)) {
      message += `File Format is not supported`;
    } else if (rejectedFile.size > maxFileSize) {
      message += `File is too big. Max File Size is 5MB`;
    }
    return message;
  };
  const handleCheck1 = (event: any) => {
    setSaveDisable(false);
    const {
      target: { value }
    } = event;
    setSqReportData({
      ...sqReportData,
      [event.target.name]: (typeof value === 'string' ? value.split(',') : value).toString(),
      monitoring_visit_id: selectedRowData.id
    });
    if (Object.keys(validationObjSqReportData).includes(event.target.name)) {
      setValidationObjSqReportData({ ...validationObjSqReportData, [event.target.name]: false });
    }
    setConfirmExitValue(dispatchApp, true);
  };
  const handleCheck2 = (event: any) => {
    setSaveDisable(false);
    const {
      target: { value }
    } = event;
    setSqReportData({
      ...sqReportData,
      [event.target.name]: (typeof value === 'string' ? value.split(',') : value).toString(),
      monitoring_visit_id: selectedRowData.id
    });
    if (Object.keys(validationObjSqReportData).includes(event.target.name)) {
      setValidationObjSqReportData({ ...validationObjSqReportData, [event.target.name]: false });
    }
    setConfirmExitValue(dispatchApp, true);
  };

  useEffect(() => {
    //setSiteSelected(selectedSite.selectedsite);
    setReportId(sqReportData.id);
  }, [selectedSite, sqReportData]);

  const {
    contextMenu,
    setContextMenu,
    queryKeys,
    setQueryKeys,
    checkListQueries,
    raisedQueries,
    totalFieldQueries,
    totalSectionQueries,
    fieldQueries,
    getSivReportQueries,
    raisedSectionQueries,
    report_id: reportId,
    setReport_id: setReportId,
    queryType,
    setQueryType,
    latestSecQueryRaisedBy
  } = useQueryMenus('SQ REPORT');

  const handleContextMenu = (event: React.MouseEvent, checklistItem: string) => {
    if (!readOnlyUser) {
      event.preventDefault();
      setContextMenu(
        contextMenu === null && !sqReportData.sq_report_signature
          ? checkPermission('view_queries_sq_report') ||
            checkPermission('view_audit_sq_report') ||
            checkPermission('raise_query_sq_report')
            ? {
                mouseX: event.clientX - 2,
                mouseY: event.clientY - 4
              }
            : null
          : null
      );
      const sectionFieldNames: string[] = [];
      Object.keys(checkListQueries.qualification_report).forEach((obj: any) => {
        sectionFieldNames.push(checkListQueries.qualification_report[obj].report_field_name);
      });
      const newObj = {
        ...checkListQueries.qualification_report[checklistItem],
        id: reportId,
        section_key: 'qualification_report',
        report_field_value: '',
        section_field_names: sectionFieldNames,
        is_all_field_queries: true
      };
      setQueryKeys(newObj);
    }
  };

  const [openViewQuery, setOpenViewQuery] = useState(false);
  const viewNotes = (checklistItem: string, isAllFieldQueries = false) => {
    let newObj: any = {};
    if (isAllFieldQueries) {
      const sectionFieldNames: string[] = [];
      Object.keys(checkListQueries.qualification_report).forEach((obj: any) => {
        sectionFieldNames.push(checkListQueries.qualification_report[obj].report_field_name);
      });
      newObj = {
        ...checkListQueries.qualification_report[checklistItem],
        id: reportId,
        section_key: 'qualification_report',
        section_field_names: sectionFieldNames,
        is_all_field_queries: isAllFieldQueries
      };
    } else {
      newObj = {
        ...checkListQueries.qualification_report[checklistItem],
        id: reportId,
        section_key: 'qualification_report',
        report_field_value: '',
        is_all_field_queries: isAllFieldQueries
      };
    }

    setQueryKeys(newObj);
    setOpenViewQuery(true);
    setQueryType('ALL');
  };

  const [openSignConsent, setOpenSignConsent] = useState(false);
  const { isValidUserForReAuth } = useValidUserForReAuth();
  const dispatch = useDispatch();

  const [sqReportSignData, setSqReportSignData] = useState({
    name_of_signature: 'sq_report_signature',
    signed_by: '',
    name_of_date_field: 'sq_report_date',
    signed_date: '',
    signed_reason: ''
  });

  const [setESignature] = useLazySetESignQuery();

  const { getPreferredDateTimeInLocal, getPreferredDateInLocal } = usePreferedDateFormat();
  const { selectedAppSection } = useSelectedAppInfo();

  const handleSQReportSign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenSignConsent(false);
        dispatch(showLoader());
        const dataObj = {
          username: data.records.user_name,
          password: data.records.password,
          module_name: 'SQ REPORT',
          name_of_signature: sqReportSignData.name_of_signature,
          name_of_date_field: sqReportSignData.name_of_date_field,
          id: sqReportData?.id,
          columns_to_change: {
            reason: data.records.sign_reason,
            updated_by: user
          }
        };
        setSqReportSignData({
          ...sqReportSignData,
          signed_by: user,
          signed_date: getUTCDateTimeOfNow(),
          signed_reason: data.records.sign_reason
        });
        const signatureResponse: any = await setESignature({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME,
          application_section: selectedAppSection,
          application_module_section: 'SQ REPORT',
          data: dataObj
        });
        if (signatureResponse.isSuccess) {
          dispatch(setMessage({ msgDetails: 'SQ Report Signed', severity: 'success' }));
          getSqReportData();
        } else if (signatureResponse.isError) {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
        dispatch(hideLoader());
      }
    }
  };

  const sqQueriesFields = [
    'sq_site_background',
    'sq_study_activities',
    'sq_add_site_info',
    'sq_imp_manage',
    'sq_site_facilities',
    'sq_study_records',
    'sq_regulatory',
    'sq_reg_approval_bodies',
    'sq_quality_compliance',
    'sq_overall_summ',
    'sq_action_items'
  ];

  const sqReportQueries = sqQueriesFields.filter((item: any) => raisedQueries.includes(item));

  return (
    <>
      <Loader />
      <AccordionDetails className="sq-checklist-tab sq-report-tab">
        {raisedSectionQueries.includes(sectionNames.site_qualification_report) &&
          sectionNames.site_qualification_report in latestSecQueryRaisedBy &&
          SectionQueryIndication(
            latestSecQueryRaisedBy,
            sectionNames.site_qualification_report,
            viewNotes,
            'sq_site_background'
          )}
        <Grid container className="checkbox-block">
          <Grid container className="date-block">
            <Grid md={4} className="mnw24">
              <FormControl fullWidth margin="normal">
                <Item>
                  <TextField
                    name="sq_visit_date"
                    className="fieldRequired"
                    error={validationObjSqReportData.sq_visit_date}
                    helperText={validationObjSqReportData.sq_visit_date && 'Required'}
                    value={
                      checkedInStartDate
                        ? getPreferredDateInLocal(checkedInStartDate)
                        : getPreferredDateInLocal(sqReportData.sq_visit_date) || ''
                    }
                    label={qualificationReport.label1}
                    id="standard-basic"
                    variant="standard"
                    disabled
                  />
                </Item>
              </FormControl>
            </Grid>
            <Grid md={4} className="input-action mnw38">
              <p>
                {qualificationReport.label2} <span style={{ color: 'red' }}>*</span>
              </p>
              <FormControl
                className="radio-buttons-block"
                error={validationObjSqReportData.sq_site_location_value_code}
              >
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="sq_site_location_value_code"
                  className="radio-buttons"
                  value={sqReportData.sq_site_location_value_code}
                  onChange={handleCheck}
                >
                  {LocationCodeListData &&
                    LocationCodeListData.map((item: any) => {
                      return (
                        <FormControlLabel
                          key={item.id}
                          value={item.code_list_value_code}
                          control={<Radio />}
                          label={item.code_list_value}
                          name="sq_site_location_value_code"
                          checked={
                            sqReportData.sq_site_location_value_code === item.code_list_value_code ? true : false
                          }
                          disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
                        />
                      );
                    })}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>{' '}
          <Grid container>
            <Grid md={12} className="input-action mnw38">
              <p>
                {qualificationReport.label5} <span style={{ color: 'red' }}>*</span>
              </p>
              <FormControl
                className="radio-buttons-block type-of-visit-list"
                error={validationObjSqReportData.sq_type_of_visit_value_code}
              >
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="sq_type_of_visit_value_code"
                  className="radio-buttons"
                  value={sqReportData.sq_type_of_visit_value_code}
                  onChange={handleCheck}
                >
                  {VisitCodeListData &&
                    VisitCodeListData.map(
                      (item: {
                        id: React.Key | null | undefined;
                        code_list_value_code: unknown;
                        code_list_value:
                          | string
                          | number
                          | boolean
                          //import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
                          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                          | React.ReactFragment
                          | React.ReactPortal
                          | null
                          | undefined;
                      }) => {
                        return (
                          <FormControlLabel
                            key={item.id}
                            value={item.code_list_value_code}
                            control={<Radio />}
                            label={item.code_list_value}
                            checked={
                              sqReportData.sq_type_of_visit_value_code === item.code_list_value_code ? true : false
                            }
                            disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
                          />
                        );
                      }
                    )}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container className="date-block">
            <Grid md={4}>
              <Item>
                <FormControl
                  fullWidth
                  margin="normal"
                  className="left-align"
                  error={validationObjSqReportData.sq_personnel}
                >
                  <InputLabel id="demo-simple-select-label">
                    {qualificationReport.label10} <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select"
                    multiple
                    value={
                      sqReportData && sqReportData.sq_personnel != undefined
                        ? sqReportData.sq_personnel.split(',').filter(Boolean)
                        : []
                    }
                    disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
                    onChange={handleCheck1}
                    input={<OutlinedInput label="Site Personnel Present" />}
                    name="sq_personnel"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                      }
                    }}
                  >
                    {sitestudySiteInfo.personnel.map((option: any) => (
                      <MenuItem key={option.id} value={`${option.site_per_first_name} ${option.site_per_last_name}`}>
                        {`${option.site_per_first_name} ${option.site_per_last_name}`}
                      </MenuItem>
                    ))}
                  </Select>
                  {validationObjSqReportData.sq_personnel && (
                    <FormHelperText className="Mui-error">Required</FormHelperText>
                  )}
                </FormControl>
              </Item>
            </Grid>
            <Grid md={4}>
              <Item>
                <FormControl
                  fullWidth
                  margin="normal"
                  className="left-align"
                  error={validationObjSqReportData.sq_site_staff}
                >
                  <InputLabel id="demo-simple-select-label">
                    {qualificationReport.label11} <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select"
                    multiple
                    value={
                      sqReportData && sqReportData.sq_site_staff != undefined
                        ? sqReportData.sq_site_staff.split(',').filter(Boolean)
                        : []
                    }
                    disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
                    onChange={handleCheck2}
                    input={<OutlinedInput label="Site Staff Proposed" />}
                    name="sq_site_staff"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                      }
                    }}
                  >
                    {sitestudySiteInfo.personnel.map((option: any) => (
                      <MenuItem key={option.id} value={`${option.site_per_first_name} ${option.site_per_last_name}`}>
                        {`${option.site_per_first_name} ${option.site_per_last_name}`}
                      </MenuItem>
                    ))}
                  </Select>
                  {validationObjSqReportData.sq_site_staff && (
                    <FormHelperText className="Mui-error">Required</FormHelperText>
                  )}
                </FormControl>
              </Item>
            </Grid>
          </Grid>
        </Grid>
        <Grid container className="report-query-block">
          <Grid
            md={12}
            onContextMenu={e => {
              handleContextMenu(e, 'sq_site_background');
            }}
            style={!sqReportData.sq_report_signature ? { cursor: 'context-menu' } : undefined}
          >
            <SQReportRow
              indexVal="0"
              titleName={qualificationReport.label12}
              title={
                "Indicate the site's speciality, experience in clinical trials, number of trials completed till date, number of trials ongoing, competitive trials if any. Also include any other information considered in the assessment."
              }
              name="sq_site_background"
              handle={handleCheck}
              change={handleChange}
              value={sqReportData.sq_site_background || ''}
              raisedQueries={raisedQueries}
              viewNotes={viewNotes}
              raisedSectionQueries={raisedSectionQueries}
              disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
            />
          </Grid>
          <Grid
            md={12}
            onContextMenu={e => {
              handleContextMenu(e, 'sq_study_activities');
            }}
            style={!sqReportData.sq_report_signature ? { cursor: 'context-menu' } : undefined}
          >
            <SQReportRow
              indexVal="1"
              titleName={qualificationReport.label4}
              title="Study design discussion and protocol discussion, study timelines, monitoring activities, and subject recruitment."
              name="sq_study_activities"
              handle={handleCheck}
              change={handleChange}
              value={sqReportData.sq_study_activities || ''}
              raisedQueries={raisedQueries}
              viewNotes={viewNotes}
              raisedSectionQueries={raisedSectionQueries}
              disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
            />
          </Grid>
          <Grid
            md={12}
            onContextMenu={e => {
              handleContextMenu(e, 'sq_add_site_info');
            }}
            style={!sqReportData.sq_report_signature ? { cursor: 'context-menu' } : undefined}
          >
            <SQReportRow
              indexVal="2"
              titleName={qualificationReport.label15}
              title="Site experience with clinical research studies, site workload, planned changes, satellite locations."
              name="sq_add_site_info"
              handle={handleCheck}
              change={handleChange}
              value={sqReportData.sq_add_site_info || ''}
              raisedQueries={raisedQueries}
              viewNotes={viewNotes}
              raisedSectionQueries={raisedSectionQueries}
              disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
            />
          </Grid>
          <Grid
            md={12}
            onContextMenu={e => {
              handleContextMenu(e, 'sq_imp_manage');
            }}
            style={!sqReportData.sq_report_signature ? { cursor: 'context-menu' } : undefined}
          >
            <SQReportRow
              indexVal="3"
              titleName={qualificationReport.label16}
              title="Storage, dispensing, accounting and end of trial procedure, IMP transportation procedures."
              name="sq_imp_manage"
              handle={handleCheck}
              change={handleChange}
              value={sqReportData.sq_imp_manage || ''}
              raisedQueries={raisedQueries}
              viewNotes={viewNotes}
              raisedSectionQueries={raisedSectionQueries}
              disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
            />
          </Grid>
          <Grid
            md={12}
            onContextMenu={e => {
              handleContextMenu(e, 'sq_site_facilities');
            }}
            style={!sqReportData.sq_report_signature ? { cursor: 'context-menu' } : undefined}
          >
            <SQReportRow
              indexVal="4"
              titleName={qualificationReport.label17}
              title="Sufficient and appropriate space, required current site certifications, site equipment & ancillary supplies current."
              name="sq_site_facilities"
              handle={handleCheck}
              change={handleChange}
              value={sqReportData.sq_site_facilities || ''}
              raisedQueries={raisedQueries}
              viewNotes={viewNotes}
              raisedSectionQueries={raisedSectionQueries}
              disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
            />
          </Grid>
          <Grid
            md={12}
            onContextMenu={e => {
              handleContextMenu(e, 'sq_study_records');
            }}
            style={!sqReportData.sq_report_signature ? { cursor: 'context-menu' } : undefined}
          >
            <SQReportRow
              indexVal="4"
              titleName={qualificationReport.label18}
              title="Type of source data, access and other details."
              name="sq_study_records"
              handle={handleCheck}
              change={handleChange}
              value={sqReportData.sq_study_records || ''}
              raisedQueries={raisedQueries}
              viewNotes={viewNotes}
              raisedSectionQueries={raisedSectionQueries}
              disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
            />
          </Grid>
          <Grid
            md={12}
            onContextMenu={e => {
              handleContextMenu(e, 'sq_regulatory');
            }}
            style={!sqReportData.sq_report_signature ? { cursor: 'context-menu' } : undefined}
          >
            <SQReportRow
              indexVal="5"
              titleName={qualificationReport.label19}
              title="Any country specific regulatory requirements."
              name="sq_regulatory"
              handle={handleCheck}
              change={handleChange}
              value={sqReportData.sq_regulatory || ''}
              raisedQueries={raisedQueries}
              viewNotes={viewNotes}
              raisedSectionQueries={raisedSectionQueries}
              disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
            />
          </Grid>
          <Grid
            md={12}
            onContextMenu={e => {
              handleContextMenu(e, 'sq_reg_approval_bodies');
            }}
            style={!sqReportData.sq_report_signature ? { cursor: 'context-menu' } : undefined}
          >
            <SQReportRow
              indexVal="6"
              titleName={qualificationReport.label20}
              title="Summary of IRB/ EC/ other regulatory bodies timelines, requirements and memberships."
              name="sq_reg_approval_bodies"
              handle={handleCheck}
              change={handleChange}
              value={sqReportData.sq_reg_approval_bodies || ''}
              raisedQueries={raisedQueries}
              viewNotes={viewNotes}
              raisedSectionQueries={raisedSectionQueries}
              disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
            />
          </Grid>
          <Grid
            md={12}
            onContextMenu={e => {
              handleContextMenu(e, 'sq_quality_compliance');
            }}
            style={!sqReportData.sq_report_signature ? { cursor: 'context-menu' } : undefined}
          >
            <SQReportRow
              indexVal="7"
              titleName={qualificationReport.label21}
              title="Including debarment checks."
              name="sq_quality_compliance"
              handle={handleCheck}
              change={handleChange}
              value={sqReportData.sq_quality_compliance || ''}
              raisedQueries={raisedQueries}
              viewNotes={viewNotes}
              raisedSectionQueries={raisedSectionQueries}
              disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
            />
          </Grid>
          <Grid
            md={12}
            onContextMenu={e => {
              handleContextMenu(e, 'sq_overall_summ');
            }}
            style={!sqReportData.sq_report_signature ? { cursor: 'context-menu' } : undefined}
          >
            <SQReportRow
              indexVal="8"
              titleName={qualificationReport.label22}
              name="sq_overall_summ"
              handle={handleCheck}
              change={handleChange}
              value={sqReportData.sq_overall_summ || ''}
              raisedQueries={raisedQueries}
              viewNotes={viewNotes}
              raisedSectionQueries={raisedSectionQueries}
              disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
            />
          </Grid>
          <Grid
            md={12}
            onContextMenu={e => {
              handleContextMenu(e, 'sq_action_items');
            }}
            style={!sqReportData.sq_report_signature ? { cursor: 'context-menu' } : undefined}
          >
            <SQReportRow
              indexVal="9"
              titleName={qualificationReport.label23}
              name="sq_action_items"
              handle={handleCheck}
              change={handleChange}
              value={sqReportData.sq_action_items || ''}
              raisedQueries={raisedQueries}
              viewNotes={viewNotes}
              raisedSectionQueries={raisedSectionQueries}
              disabled={!perDisable || (sqReportData?.is_submit && !readOnlyUser) || !checkedInStartDate}
            />
          </Grid>

          {checkPermission('update_sq_report') ? (
            <Grid md={12}>
              <Button
                className="modal-btn"
                variant="outlined"
                onClick={handleClickOpenUploadDocument}
                disabled={(sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
              >
                <AddCircleIcon />
                {qualificationReport.label24}
              </Button>
              <div>
                <ul style={{ marginLeft: 0 }}>
                  {fileObjects.map((item: any) => {
                    return (
                      <Chip
                        key={item.id}
                        label={item.ctms_raw_file_name}
                        variant="outlined"
                        color="primary"
                        size="small"
                        onDelete={() => {
                          setDeleteUploadPopup(true);
                          setDeleteFileId(item.id);
                        }}
                      />
                    );
                  })}
                </ul>
              </div>
              <div>
                <PopupComponent
                  onClose={handleClose}
                  aria-labelledby="customized-dialog-title"
                  open={openUploadDocument}
                  maxWidth="md"
                  className="uploadModal"
                >
                  <DialogContent dividers>
                    <FileUpload
                      showPreviewsInDropzone={false}
                      className={'uploadFile withFakeBtn multiple'}
                      onChange={files => {
                        if (files.length > 0) {
                          setNewAr([...files]);
                          //setUploadedFiles([...uploadedFiles, ...files]);
                          // setUploadedFiles([...files]);
                          setIsSubmitEnable(true);
                        } else {
                          setIsSubmitEnable(false);
                        }
                      }}
                      isUpload
                      defaultMsg={'Your file upload has been successfully initiated'}
                      successMsg={'Drag and drop your file here or'}
                      fileObjects={fileObjects}
                      maxFileSize={5000000}
                      showPreviews
                      useChipsForPreview
                      previewText=""
                      getDropRejectMessage={handleRejectedMessage}
                      acceptedFiles={[
                        '.jpg',
                        '.jpeg',
                        '.gif',
                        '.png',
                        '.bmp',
                        '.tif',
                        '.tiff',
                        '.psd',
                        '.pdf',
                        '.doc',
                        '.docx',
                        '.xls',
                        '.xlsx'
                      ]}
                    />
                  </DialogContent>
                  <Alert severity="info" sx={{ mr: 2, ml: 2 }}>
                    Documents uploaded here are not stored in eTMF
                  </Alert>
                  <DialogActions>
                    <Stack direction="row" spacing={2}>
                      <Button
                        variant="text"
                        href="#contained-buttons"
                        className="grey-btn"
                        onClick={handleCloseUploadDocument}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="text"
                        href="#contained-buttons"
                        onClick={handleUploadDocument}
                        disabled={!isSubmitEnable}
                      >
                        Submit
                      </Button>
                    </Stack>
                  </DialogActions>
                </PopupComponent>
              </div>
            </Grid>
          ) : (
            <></>
          )}
          <Grid container className="date-block">
            <Grid md={3} item>
              <FormControl fullWidth margin="normal">
                <TextField
                  name="sq_date_submitted_review"
                  value={getPreferredDateInLocal(sqReportData.sq_date_submitted_review) || ''}
                  label={qualificationReport.label25}
                  variant="standard"
                  disabled
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt="16px">
            <Grid md={2.5} item>
              <Typography fontWeight="bold">Final Approval by:</Typography>
            </Grid>
            <Grid md={8} item>
              {sqReportData?.sq_report_signature ? (
                <div style={{ marginTop: '-2px' }}>
                  <span className="signedInfo">
                    Signed by{' '}
                    <strong>
                      {sqReportData?.sq_report_signature
                        ? sqReportData?.sq_report_signature
                        : sqReportData.sq_report_notify_review}
                    </strong>{' '}
                    on{' '}
                    <span color="text.secondary">
                      {sqReportData?.sq_report_date ? getPreferredDateTimeInLocal(sqReportData?.sq_report_date) : ''}
                    </span>{' '}
                    <br />
                    <span className="signReasonrow">
                      <span color="text.secondary">Reason:</span> &ldquo;{sqReportData?.reason}
                      &rdquo;
                    </span>
                  </span>
                </div>
              ) : (
                <Button
                  variant="contained"
                  onClick={() => setOpenSignConsent(true)}
                  disabled={
                    !sqReportData.is_submit ||
                    !sqReportData.sq_report_notify_review ||
                    sqReportData.sq_report_notify_review != user ||
                    !checkPermission('sign_sq_report') ||
                    !checkPermission('view_sq_report') ||
                    sqReportQueries.length > 0 ||
                    raisedSectionQueries.length > 0
                  }
                  sx={{ mt: '-4px' }}
                >
                  Sign
                </Button>
              )}
            </Grid>
          </Grid>
          <Grid container className="date-block" spacing={2}>
            <Grid md={6} item className="input-action">
              <p>
                {qualificationReport.label27}? <span style={{ color: 'red' }}>*</span>
              </p>
              <FormControl
                // className="radio-buttons-block"
                error={validationObjSqReportData.sq_site_selected_value_code}
              >
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="sq_site_selected_value_code"
                  className="radio-buttons"
                  value={sqReportData?.sq_site_selected_value_code}
                  onChange={handleCheck}
                >
                  {ResponseCodeListData &&
                    ResponseCodeListData.map((item: any) => {
                      if (item.code_list_value_code !== 'NA') {
                        return (
                          <FormControlLabel
                            key={item.id}
                            value={item.code_list_value_code}
                            checked={
                              sqReportData.sq_site_selected_value_code === item.code_list_value_code ? true : false
                            }
                            control={<Radio />}
                            label={item.code_list_value}
                            disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
                          />
                        );
                      }
                    })}
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid md={12} item className="input-action confirm-check-block">
              <FormGroup>
                <FormControlLabel
                  className="fieldRequired"
                  disabled={!perDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
                  checked={agree}
                  control={<Checkbox id="agree" onChange={checkboxHandler} />}
                  label={qualificationReport.label29}
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      {checkPermission('update_sq_report') && checkPermission('view_sq_report') ? (
        <Grid container className="fixed-buttons-block">
          <Grid md={12} display="flex" justifyContent="flex-end">
            <Stack spacing={2} direction="row">
              <FormControl sx={{ m: 1, minWidth: 120 }}>
                <Select
                  id="demo-simple-select"
                  value={sqReportData.sq_report_signature ? 'Reviewed' : submitStatus}
                  onChange={submitStatusChange}
                  disabled={sqReportData?.is_submit || !checkedInStartDate}
                  size="small"
                >
                  {sqReportData.sq_report_signature ? (
                    <MenuItem key="reviewed" value="Reviewed">
                      Reviewed
                    </MenuItem>
                  ) : (
                    StatusCodeListData &&
                    StatusCodeListData.map((option: any) => (
                      <MenuItem key={option.id} value={option.code_list_value_code}>
                        {option.code_list_value}
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
              {submitStatus != '2' || sqReportData?.is_published === true ? (
                <Button
                  onClick={handleSave}
                  variant="text"
                  disabled={saveDisable || (sqReportData.is_submit && !readOnlyUser) || !checkedInStartDate}
                >
                  SAVE
                </Button>
              ) : null}
            </Stack>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
      <PopupComponent
        open={enable}
        child
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Cancel Document Upload'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to cancel uploading this document?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={clearData} autoFocus className="grey-btn">
            Yes
          </Button>
          <Button onClick={handleClosePopUp}>No</Button>
        </DialogActions>
      </PopupComponent>
      <PopupComponent
        open={deleteUploadPopup}
        child
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Delete'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to delete the uploaded document?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRemoveItem} autoFocus>
            Yes
          </Button>
          <Button onClick={() => setDeleteUploadPopup(false)}>No</Button>
        </DialogActions>
      </PopupComponent>

      {openSignConsent && (
        <ESignConsentReAuth
          openSignConsent={openSignConsent}
          setOpenSignConsent={setOpenSignConsent}
          handleConfirmSign={handleSQReportSign}
        />
      )}
      <QueryMenus
        totalFieldQueries={totalFieldQueries}
        totalSectionQueries={totalSectionQueries}
        contextMenu={contextMenu}
        setContextMenu={setContextMenu}
        queryKeys={queryKeys}
        fieldQueries={fieldQueries}
        getSivReportQueries={getSivReportQueries}
        report_id={reportId}
        checkListQueries={checkListQueries}
        queryType={queryType}
        setQueryType={setQueryType}
        isSQSivQueries
      />
      <ViewQuery
        totalFieldQueries={totalFieldQueries}
        totalSectionQueries={totalSectionQueries}
        open={openViewQuery}
        setOpen={setOpenViewQuery}
        queryKeys={queryKeys}
        queryType={queryType}
        fieldQueries={fieldQueries}
        getSivReportQueries={getSivReportQueries}
        setQueryType={setQueryType}
        report_id={reportId}
        isSQSivQueries
      />
    </>
  );
};

export default SQReport;
